import store from '@/store/index';
import { translation } from '@/plugins/i18n';
import { filter, get, reduce, includes } from 'lodash';
import BillingMessageBox from '@/components/common/message-box';
import { BILLING_CYCLE, limitBillingCycleWithBaseZoneTypes, limitLicenseWithBaseZoneTypes, planTypes, BASE_PLAN_TYPES } from '@/common/constants';
import { isBizPlusContext, isEduSchCmpPlusContext } from '@/plans/ZOOM_MEETING/common/utils';

export const getPlanTotalLicense = (planList = []) => {
  return reduce(planList, (pre, plan) => {
    return (pre = pre + plan.cartInfo?.selected_number);
  }, 0);
};

export const getPlanTotalLicenseFilteredFreeTrial = (planList = []) => {
  return reduce(planList, (pre, plan) => {
    return (pre = pre + (!plan.isOnlineFreeTrial ? plan.cartInfo?.selected_number: 0));
  }, 0);
};

const getPlanNameList = (planList = []) => {
  return reduce(planList, (pre, plan) => {
    return [
      ...pre,
      translation(plan?.typeNameKey),
    ]
  }, []);
}

const getValidationAddonPlans = (filterAddonPlanTypes = []) => {
  const { getCurrentBasePlanInfo, getSelectedPlans = [] } = store.getters;
  let basePlanList = [];
  if (isBizPlusContext) {
    const planList = getSelectedPlans.filter(item => [planTypes.ZOOM_MEETING, planTypes.ZOOM_ONE_BUNDLE].includes(item.type));
    BASE_PLAN_TYPES.forEach(item => {
      const plan = planList.filter(p => p.type === item);
      if (plan.length) {
        basePlanList = basePlanList.concat(plan);
      }
    });
  } else {
    basePlanList = getCurrentBasePlanInfo.plans || [];
  }
  const addonPlanList = filter(getSelectedPlans, (p) => {
    if (p.type === planTypes.WEBINAR && p.billing_cycle === BILLING_CYCLE.ONE_TIME) {
      return false;
    }
    return includes(filterAddonPlanTypes, p?.type);
  });

  return {
    basePlanList,
    addonPlanList,
  }
}

const validAddonBillingCycleWithBasePlan = async () => {
  const { basePlanList, addonPlanList } = getValidationAddonPlans(limitBillingCycleWithBaseZoneTypes);

  if (addonPlanList.length > 0) {
    const basePlan = get(basePlanList, '0');
    const basePlanBillingCycle = get(basePlan, 'billing_cycle');
    const basePlanTypeName = translation(basePlan?.typeNameKey);

    // check base plan with addon plan's billing cycle
    const notValidBillingCyclePlanList = filter(addonPlanList, (plan) => {
      const { billing_cycle, billingCycleDependBasePlanTypeList } = plan;
      return (
        Array.isArray(billingCycleDependBasePlanTypeList) &&
        billingCycleDependBasePlanTypeList.includes(basePlan.type) &&
        basePlanBillingCycle === BILLING_CYCLE.MONTHLY &&
        billing_cycle === BILLING_CYCLE.ANNUAL
      );
    });

    if (notValidBillingCyclePlanList.length) {
      const addonPlanTypeNames = getPlanNameList(notValidBillingCyclePlanList);

      BillingMessageBox.alert(
        translation('billing.planform.annual_addon_disable_tooltip', [basePlanTypeName, [...new Set(addonPlanTypeNames)].join(", "), basePlanTypeName]),
        translation('billing.buyItNow.cant_continue'),
      );

      return Promise.reject();
    }
  }

  return Promise.resolve();
}

const validAddonLicensesWithBasePlan = async () => {
  const { basePlanList, addonPlanList } = getValidationAddonPlans(limitLicenseWithBaseZoneTypes);

  if (addonPlanList.length > 0) {
    const basePlan = get(basePlanList, '0');
    const basePlanTypeName = translation(basePlan?.typeNameKey);
    let basePlanLicenses = get(basePlan, 'cartInfo.selected_number');

    if (isBizPlusContext || isEduSchCmpPlusContext) {
      basePlanLicenses = getPlanTotalLicense(basePlanList);
    }

    const notValidLicensePlanList = filter(addonPlanList, (plan) => {
      const currentLicenses = plan?.cartInfo?.selected_number;
      return currentLicenses > basePlanLicenses;
    });

    // check base plan with addon plan's license
    if (notValidLicensePlanList.length) {
      const addonPlanTypeNames = getPlanNameList(notValidLicensePlanList);

      BillingMessageBox.alert(
        translation('billing.licences_limit_tips', [addonPlanTypeNames.join(", "), basePlanTypeName]),
        translation('billing.buyItNow.cant_continue'),
      );

      return Promise.reject();
    }
  }

  return Promise.resolve();
}

export const validAddonPlansWithBasePlan = async () => {
  await validAddonBillingCycleWithBasePlan();
  await validAddonLicensesWithBasePlan();
}
